import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from "react-redux";

import "@fontsource/poppins/400";
import "@fontsource/poppins/500";
import "@fontsource/poppins/600";
import "@fontsource/poppins/700";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import store from "./store";

// MUI components (modals, tables) use the theme's font, Roboto by default
const theme = createTheme({ typography: { fontFamily: "'Poppins', -apple-system, 'Segoe UI', 'Helvetica Neue', sans-serif" } });

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <React.StrictMode>
        <ThemeProvider theme={theme}>
          <App />
        </ThemeProvider>
      </React.StrictMode>
    </BrowserRouter>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
